import React from "react";
import { useWatch } from "react-hook-form";
import SegmentSummary from "../../../components/SegmentSummary/SegmentSummary";
import { useEditSegmentView } from "../EditSegment.context";

function SummaryPanel() {
  const { form, segmentDetails } = useEditSegmentView();

  const [filter, setFilter] = React.useState(segmentDetails?.filter);

  const data = useWatch();

  const segmentIdRef = React.useRef<string | undefined>(segmentDetails?.id);
  const [initialSummaryLoaded, setInitialSummeryLoaded] = React.useState(false);

  const {
    formState: { isValid, isDirty },
    reset,
  } = form;

  React.useEffect(() => {
    if (isValid && Object.keys(data).length > 0) {
      setFilter(data as any);
    }
  }, [data, isValid]);

  const isRefreshDisabled = React.useMemo(() => {
    if (!initialSummaryLoaded) {
      return false;
    }
    return !(isValid && isDirty);
  }, [initialSummaryLoaded, isValid, isDirty]);

  if (!segmentDetails?.filter || Object.keys(data).length === 0) {
    return null;
  }

  const handleReset = () => {
    reset({}, { keepValues: true });
    setInitialSummeryLoaded(true);
  };

  return (
    <SegmentSummary
      filter={filter || segmentDetails?.filter}
      segmentId={segmentIdRef.current}
      isFilterValid={isValid}
      refreshDisabled={isRefreshDisabled}
      onRefreshClick={handleReset}
      skipInitialSummaryFetch={true}
    />
  );
}

export default React.memo(SummaryPanel);
